import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCircle = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	height: "1em",
	width: "1em",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0.750 11.999 A11.250 11.250 0 1 0 23.250 11.999 A11.250 11.250 0 1 0 0.750 11.999 Z",
		fill: "none",
		stroke: "var(--icon-color, currentColor)",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5
	})
});
export default SvgCircle;
